/**
 * Image URL for display.
 * Instagram CDN blocks browsers; use wsrv.nl proxy so images load on web (like mobile).
 */
const WSRV_PROXY = 'https://wsrv.nl/';

function isInstagramCdn(url: string): boolean {
  try {
    const host = new URL(url).hostname;
    return host.includes('cdninstagram.com') || host.includes('instagram.com') || host.includes('fbcdn.net');
  } catch {
    return false;
  }
}

function getOriginalUrl(url: string): string {
  if (url.includes('proxy-image') && url.includes('url=')) {
    try {
      const parsed = new URL(url);
      const original = parsed.searchParams.get('url');
      return original ? decodeURIComponent(original) : url;
    } catch {
      return url;
    }
  }
  return url;
}

export function getDisplayImageUrl(url: string | null | undefined): string | null {
  if (!url) return null;
  const original = getOriginalUrl(url);
  if (!isInstagramCdn(original)) return url;
  return `${WSRV_PROXY}?url=${encodeURIComponent(original)}`;
}
